<template>
<div>
   <vs-row vs-type="flex">
      <ValidationObserver ref="addMultipleObserver">
        <vs-col vs-justify="flex-start" vs-lg="3" class="p-3">
          <ValidationProvider :name="$t('CashFlow.YearlyInflationRate.Category')" rules="required" v-slot="{ errors }">
            <form-label>{{$t('CashFlow.YearlyInflationRate.Category')}}</form-label>
            <v-select
              :options="categories"
              label="name"
              :reduce="cat => cat.id"
              v-model="category"
              class="w-full"
              name="categoryId"
            />
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col vs-justify="flex-start" vs-lg="2" class="p-3">
          <ValidationProvider :name="$t('CashFlow.YearlyInflationRate.StartYear')" rules="required|numeric|between:1990,2100" v-slot="{ errors }">
            <validated-input :label="$t('CashFlow.YearlyInflationRate.StartYear')" 
              v-model="startYear"
              class="nowrap">
            </validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col vs-justify="flex-start" vs-lg="2" class="p-3">
          <ValidationProvider :name="$t('CashFlow.YearlyInflationRate.EndYear')" rules="required|numeric|between:1990,2100" v-slot="{ errors }">
            <validated-input :label="$t('CashFlow.YearlyInflationRate.EndYear')" 
              v-model="endYear"
              class="nowrap">          
            </validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col vs-justify="flex-start" vs-lg="1" class="p-3">
          <ValidationProvider :name="$t('CashFlow.YearlyInflationRate.Rate')" rules="required|decimal|between:0,100" v-slot="{ errors }">
            <validated-input :label="$t('CashFlow.YearlyInflationRate.Rate')" 
              v-model="rate"
              class="nowrap">
            </validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col v-if="!readOnly" vs-type="flex" vs-justify="flex-start" vs-lg="3" class="align-items-center mt-8 pt-1" >
          <vs-button type="border" class="align-items-center" color="danger" @click="addMultipleRates" >{{ $t('CashFlow.YearlyInflationRate.BatchAddTitle') }}</vs-button>
        </vs-col>
      </ValidationObserver>
    </vs-row>
    <vs-row class="yesscroll mb-10">
      <yearly-inflation-rates-table :yearlyRates="yearlyRates" />
    </vs-row>
</div>

</template>
<script>

import InflationCategoryEnum from "../../../InflationCategoryEnum";
import vSelect from 'vue-select';
import YearlyInflationRatesTable from './yearlyInflationRatesTable.vue'

import {
  FormLabel,
  ValidatedInput,
  ValidationMessage
} from "@/app/shared/components";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    FormLabel,    
    vSelect,
    ValidatedInput,
    ValidationMessage,
    YearlyInflationRatesTable
  },
  props: {
    readOnly : {
      type: Boolean,
      default: false
    },
    templateId : {
      type: Number
    },
    yearlyRates: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      isMounted: false,
      startYear: null,
      endYear: null,
      category: null,
      rate: 0,
      context: { componentParent: this },
      categories: [
        { name: this.getCategoryName(InflationCategoryEnum.OpenPitCost), id: InflationCategoryEnum.OpenPitCost },
        { name: this.getCategoryName(InflationCategoryEnum.UndergroundCost), id: InflationCategoryEnum.UndergroundCost },
        { name: this.getCategoryName(InflationCategoryEnum.HeapLeachCost), id: InflationCategoryEnum.HeapLeachCost },
        { name: this.getCategoryName(InflationCategoryEnum.MillCost), id: InflationCategoryEnum.MillCost },
        { name: this.getCategoryName(InflationCategoryEnum.SiteCost), id: InflationCategoryEnum.SiteCost },
        { name: this.getCategoryName(InflationCategoryEnum.SustainingCapital), id: InflationCategoryEnum.SustainingCapital },
        { name: this.getCategoryName(InflationCategoryEnum.GrowthCapital), id: InflationCategoryEnum.GrowthCapital }
      ]
    };
  },
  created() {
    this.initValues();
  },

  computed: {
  },

  methods: {
    initValues() {
      if (this.data) return;
      this.startYear = new Date().getFullYear();
      this.endYear = null;
      this.category = InflationCategoryEnum.OpenPitCost;
      this.rate = 0;
    },
    addMultipleRates() {
      this.$refs.addMultipleObserver.validate().then(result => {
        if (result) {
          this.$vs.loading();
          this.$cqrsPost('cashflow/lom/yearlyInflationRateTemplates/addMultipleRates', { 
            templateId: this.templateId,
            category: this.category,
            startYear: this.startYear,
            endYear: this.endYear,
            rate: this.rate
          }).then((response) => {
            this.$notifySaveSuccess();
            this.$emit("onRebindYearlyRates", response.data.model);
          }).finally(() => {
            this.$vs.loading.close();
          });
        }
      });
    },
    getCategoryName(category) {
      return this.$t("CashFlow.InflationCategory." + category);
    }
  }
};
</script>

<style lang="scss">


  .nowrap {
    white-space: nowrap;
  }

  .yesscroll {
    overflow-x: auto;
  }

</style>